export default __webpack_public_path__ + "static/media/mockup-tips.c630489c.png";